// Browsing history - recent proxied destinations, persisted to localStorage.
// Recording honors both the keepHistory setting and incognito mode.
import { readJSON, writeJSON, subscribe as subStore } from "../shared/store.js";
import { HISTORY_KEY, HISTORY_LIMIT } from "../shared/settings-schema.js";
import { get } from "../shared/settings-store.js";

export function list() {
	const v = readJSON(HISTORY_KEY, []);
	return Array.isArray(v) ? v : [];
}

export function record(url, title) {
	const u = (url || "").trim();
	if (!u || !/^https?:/i.test(u)) return;
	if (!get("keepHistory") || get("incognito")) return;
	const items = list().filter((h) => h.url !== u);
	items.unshift({ url: u, title: (title || u).slice(0, 120), ts: Date.now() });
	if (items.length > HISTORY_LIMIT) items.length = HISTORY_LIMIT;
	writeJSON(HISTORY_KEY, items);
}

export function recent(n) { return list().slice(0, n || 8); }

export function remove(url) {
	const u = (url || "").trim();
	writeJSON(HISTORY_KEY, list().filter((h) => h.url !== u));
}

export function clear() { writeJSON(HISTORY_KEY, []); }

export function subscribe(fn) { return subStore(HISTORY_KEY, fn); }
